import { Alert, Card, List, Typography } from 'antd';
import type { AiTextPayload } from '../../../types/ai-analysis.types';
export default function AiDetailedAnalysisView({
  payload,
  warnings = [],
}: {
  payload: AiTextPayload;
  warnings?: string[];
}) {
  return (
    <Card title={payload.title}>
      <Typography.Paragraph>{payload.introduction}</Typography.Paragraph>
      <List
        dataSource={payload.findings}
        renderItem={(finding) => (
          <List.Item>
            <List.Item.Meta title={finding.heading} description={finding.text} />
          </List.Item>
        )}
      />
      {payload.limitations?.length > 0 && (
        <Alert type="warning" message="Limitações" description={payload.limitations.join(' • ')} />
      )}
      {warnings.map((warning) => (
        <Alert key={warning} type="warning" message={warning} />
      ))}
      <Typography.Paragraph>{payload.conclusion}</Typography.Paragraph>
    </Card>
  );
}
